import { render, staticRenderFns } from "./comp_RatioIframe.vue?vue&type=template&id=1051210a&"
import script from "./comp_RatioIframe.vue?vue&type=script&lang=js&"
export * from "./comp_RatioIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports